import { render, staticRenderFns } from "./adminUser.vue?vue&type=template&id=5c56b270&scoped=true&"
import script from "./adminUser.vue?vue&type=script&lang=js&"
export * from "./adminUser.vue?vue&type=script&lang=js&"
import style0 from "./adminUser.vue?vue&type=style&index=0&id=5c56b270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56b270",
  null
  
)

export default component.exports